"use strict";
import { Entity, Related, Collection } from "../util/pine/cache_configuration";
export default {
  apiEndpoint: "/api/accounts_payable/needs.json",
  activityItem: Entity("activityItems"),
  carrierInvoice: Entity("carrierInvoices"),
  currentAccount: Entity("currentAccount"),
  currentUser: Entity("currentUser"),
  documentBatch: Entity("documentBatch"),
  documentBatchIdsByFactorInvoiceId: Related(),
  documentGroup: Entity("documentGroup"),
  emailMessage: Entity("emailMessage"),
  exceptionedItemIdsByEmailMessageId: Entity("exceptionedItemIdsByEmailMessageId"),
  exceptionEvent: Entity("exceptionEvent"),
  exceptionEventsByOwner: Entity("exceptionEventsByOwner"),
  exceptionedItem: Entity("exceptionedItem"),
  networkBroker: Entity("networkBroker"),
  factorBroker: Entity("factorBroker"),
  factorBrokerPaymentAddress: Entity("factorBrokerPaymentAddress"),
  factorInvoice: Entity("factorInvoices"),
  factorInvoiceBadQualityPages: Entity("factorInvoiceBadQualityPages"),
  factorInvoiceSubmissions: Entity("factorInvoiceSubmissions"),
  loadState: Entity("loadStates"),
  newEmailIds: Entity("newEmailIds"),
  pagedActivityItemIdSearch: Entity("pagedActivityItemIdSearch"),
  paymentAddress: Entity("paymentAddress"),
  processedFactorInvoiceIdGroups: Entity("processedFactorInvoiceIdGroups"),
  processedInvoiceIds: Entity("processedInvoiceIds"),
  replyEmailIds: Entity("replyEmailIds"),
  tmsCarrier: Entity("tmsCarrier"),
  tmsCustomer: Entity("tmsCustomer"),
  tmsLoad: Entity("tmsLoads"),
  unsentExceptionIds: Entity("unsentExceptionIds"),
  user: Entity("user"),
  users: Collection("users"),
  waitingExceptionIds: Entity("waitingExceptionIds")
};
